import '@gyym/ui/styles/global.css'

import { GyymProvider } from '@gyym/sdk-react'
import {
  Config as GyymUiConfig,
  defaultTheme,
  DialogProvider,
  GyymUiProvider,
  ModalProvider,
  SnackbarProvider,
} from '@gyym/ui'
import type { AppProps } from 'next/app'
import { Noto_Sans_JP } from 'next/font/google'
import Head from 'next/head'
import { SWRConfiguration } from 'swr'

import { gyymClient } from '@/lib/gyym'

const notoSansJp = Noto_Sans_JP({
  subsets: ['latin'],
  weight: ['300', '400', '500'],
  display: 'swap',
})

const gyymUiConfig: GyymUiConfig = {
  imageHost: process.env.NEXT_PUBLIC_IMAGE_HOST,
  nextjs: {
    disableNextLink: false,
    disableNextImage: false,
    disableImageOptimization: false,
    // Pages Router の viewport prefetch は gSSP を持つ遷移先ごとに
    // _next/data リクエストを発生させるため、明示指定のない Link では止める
    disableLinkPrefetch: () => true,
  },
}

if (process.env.NEXT_PUBLIC_ENABLE_API_MOCK === 'true') {
  const MockServer = () => import('@/mocks')
  MockServer()
}

function MyApp({ Component, pageProps }: AppProps<{ swr?: SWRConfiguration }>) {
  return (
    <>
      <Head>
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width,initial-scale=1.0"
        />
      </Head>

      <GyymProvider
        client={gyymClient}
        swr={{
          ...pageProps.swr,
          revalidateOnMount: false,
          revalidateIfStale: false,
          revalidateOnFocus: true,
          revalidateOnReconnect: true,
        }}
      >
        <GyymUiProvider theme={defaultTheme} config={gyymUiConfig}>
          <SnackbarProvider>
            <ModalProvider>
              <DialogProvider>
                <main className={notoSansJp.className}>
                  <Component {...pageProps} />
                </main>
              </DialogProvider>
            </ModalProvider>
          </SnackbarProvider>
        </GyymUiProvider>
      </GyymProvider>
    </>
  )
}

// export function reportWebVitals(metric: NextWebVitalsMetric) {
//   console.log(metric)
// }

export default MyApp
